<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  template(v-if="isCheckBox")
    el-checkbox-group(:value="inputValue", @input="updateValue", @change="onChange", :disabled="!isEdit")
      el-checkbox(v-for="{ dicId, label } in formatList", :key="dicId", :label="dicId") {{ label }}
  template(v-else-if="isRadio")
    el-radio-group(:value="inputValue", @input="updateValue", @change="onChange", :disabled="!isEdit")
      el-radio(v-for="{ dicId, label } in formatList", :key="dicId", :label="dicId") {{ label }}
  template(v-else)
    template(v-if="isEdit")
      el-select.select.width-full(:value="inputValue", @input="updateValue", clearable, filterable, :multiple="multiple", @change="onChange")
        el-option(v-for="{ dicId, label } in formatList", :key="dicId", :label="label", :value="dicId")
    .readonly-mode-field(v-else) {{ formatLabel }}
</template>
<script>
import { cloneDeep, mapVFAssignField, staticMixins, template } from "@/CommonDP/VForm/utils";
import { getDictListByCode, VF_DICT_ENUM } from "./index.js";
const separator = ",";
export default {
  mixins: [staticMixins],
  data() {
    return {
      list: [],
      rules: []
    };
  },
  computed: {
    ...mapVFAssignField({ fieldLabel: "displayFieldName" }),
    formatLabel() {
      const value = this.fieldLabel || this.getLabelByModel();
      return value ? `${value}` : "";
    },
    newRules() {
      const { rules, required } = this;
      const list = [];
      if (required) {
        list.push({ required: this.options.required, message: this.options.requiredHint });
      }
      return [...rules, ...list];
    },
    multiple() {
      return this.options.multiple_;
    },
    isCheckBox() {
      return this.multiple && this.options.controlStyle === "checkbox";
    },
    isRadio() {
      return !this.multiple && this.options.controlStyle === "checkbox";
    },
    vmDefaultValue() {
      return cloneDeep(this.defaultDict);
    },
    defaultDict() {
      const data = this.options.defaultDict;
      return Array.isArray(data) ? data.join(separator) : data;
    },
    dictType() {
      return this.options.dictType;
    },
    // 字典项 - 名称
    displayFieldName() {
      return this.options.displayFieldName;
    },
    dictDisplayMode() {
      return this.options.dictDisplayMode;
    },
    // 经过格式化处理的字典
    formatList() {
      const { getFormat, list } = this;
      return list.map((dict) => ({ ...dict, label: getFormat(dict) }));
    },
    // fieldModel 表单挂载数据 为字符串
    // inputValue 根据当前情况转换成ele组件可以正常显示的数据
    // 在组件通过@input把将修改的数据转换为字符串
    inputValue() {
      const { fieldModel, multiple } = this;
      return multiple ? (fieldModel ? fieldModel.split(separator) : []) : fieldModel;
    }
  },

  watch: {
    dictType: {
      immediate: true,
      handler() {
        this.getDict();
      }
    }
  },

  methods: {
    updateValue(data) {
      this.fieldModel = Array.isArray(data) ? data.join(separator) : data;
    },
    onChange() {
      this.customEvent("onChange", this.fieldModel, this.fieldLabel);
      this.emitValidate();
    },
    withUpdate() {
      this.fieldLabel = this.getLabelByModel();
    },
    getLabelByModel() {
      const { formatList, inputValue, multiple } = this;
      const list = multiple ? inputValue : inputValue ? [inputValue] : [];
      const labelList = list.map((id) => formatList.find(({ dicId }) => dicId === id)?.label);
      return labelList.join(separator);
    },
    getFormat({ dicId: key, cnName: label }) {
      const { dictDisplayMode = "" } = this;
      return template(dictDisplayMode || VF_DICT_ENUM.label)({ key, label });
    },
    async getDict(force = false) {
      const { dictType } = this;
      this.list = [];
      const fn = this.customEvent("onQuery");
      const list = await getDictListByCode(dictType, force);
      fn instanceof Function && await fn.call(this, list);
      this.list = list;
      this.fieldLabel = this.getLabelByModel();
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
